// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Fetch from "bs-fetch/src/Fetch.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as FutureJs from "reason-future/src/FutureJs.bs.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils_Json$LiveRoom from "./Utils/Utils_Json.bs.js";
import * as SharedTypes$LiveRoom from "./types/SharedTypes.bs.js";

function makeQueryHeaders(maybeAccessToken) {
  var headers = {};
  headers["content-type"] = "application/json";
  if (maybeAccessToken !== undefined) {
    headers["authorization"] = "Bearer " + maybeAccessToken;
  }
  return headers;
}

function makeQueryBody(query) {
  return JSON.stringify(Js_dict.fromList(Belt_List.concatMany([{
                        hd: [
                          "query",
                          query
                        ],
                        tl: /* [] */0
                      }])));
}

function parseResponseJson(json) {
  return {
          data: Utils_Json$LiveRoom.Decode.toOptionJson(json, "data"),
          errors: Utils_Json$LiveRoom.Decode.toOptionArrayJson(json, "errors")
        };
}

function MakeQuery(T) {
  var makeClient = function (maybeAccessToken) {
    return fetch(Curry._1(T.graphQLUrl, undefined), Fetch.RequestInit.make(/* Post */2, Caml_option.some(makeQueryHeaders(maybeAccessToken)), Caml_option.some(makeQueryBody(T.Query.query)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
  };
  var parse = function (response) {
    try {
      var match = response.data;
      var match$1 = response.errors;
      if (match === undefined) {
        if (match$1 !== undefined) {
          return {
                  NAME: "Error",
                  VAL: Belt_List.fromArray(Belt_Array.map(match$1, SharedTypes$LiveRoom.Errors.graphQLerrorDecoder))
                };
        } else {
          return {
                  NAME: "Error",
                  VAL: {
                    hd: {
                      message: "No data",
                      locations: /* [] */0,
                      extensions: {
                        code: undefined,
                        messageUser: undefined,
                        type_: ""
                      }
                    },
                    tl: /* [] */0
                  }
                };
        }
      }
      var data = Caml_option.valFromOption(match);
      if (match$1 !== undefined) {
        return {
                NAME: "DataWithError",
                VAL: [
                  Curry._1(T.Query.parse, data),
                  Belt_List.fromArray(Belt_Array.map(match$1, SharedTypes$LiveRoom.Errors.graphQLerrorDecoder))
                ]
              };
      } else {
        return {
                NAME: "Data",
                VAL: Curry._1(T.Query.parse, data)
              };
      }
    }
    catch (exn){
      return {
              NAME: "Error",
              VAL: {
                hd: {
                  message: "Could not parse data",
                  locations: /* [] */0,
                  extensions: {
                    code: undefined,
                    messageUser: undefined,
                    type_: ""
                  }
                },
                tl: /* [] */0
              }
            };
    }
  };
  var queryAndParse = function (token, param) {
    return Js_promise.then_((function (response) {
                  return Promise.resolve(parse(response));
                }), Js_promise.then_((function (json) {
                      return Promise.resolve(parseResponseJson(json));
                    }), Js_promise.then_(Fetch.$$Response.json, makeClient(token))));
  };
  var queryAndParseFuture = function (token, param) {
    return FutureJs.fromPromise(queryAndParse(token, undefined), (function (error) {
                  return {
                          NAME: "UnknownError",
                          VAL: String(error)
                        };
                }));
  };
  return {
          makeClient: makeClient,
          parse: parse,
          queryAndParse: queryAndParse,
          queryAndParseFuture: queryAndParseFuture
        };
}

export {
  makeQueryHeaders ,
  makeQueryBody ,
  parseResponseJson ,
  MakeQuery ,
}
/* No side effect */
